import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator, httpsCallable } from "firebase/functions";

const env = import.meta.env;
export const app = initializeApp({
  apiKey: env.VITE_FB_API_KEY || "demo-key",
  authDomain: env.VITE_FB_AUTH_DOMAIN || "localhost",
  projectId: env.VITE_FB_PROJECT_ID || "demo-ahg-hub",
  appId: env.VITE_FB_APP_ID || "demo-app",
});
export const auth = getAuth(app);
export const db = getFirestore(app);
export const fns = getFunctions(app, "asia-southeast1");

if (env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(fns, "127.0.0.1", 5001);
}

export const call = <I, O>(name: string) => async (input: I): Promise<O> => (await httpsCallable<I, O>(fns, name)(input)).data;
